<template>
  <div
    v-if="data"
    class="file"
  >
    <a-upload
      :action="action"
      :multiple="true"
      :headers="{'X-Requested-With': null}"
      :accept="accept"
      :data="params"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :remove="handleRemove"
      @change="handleChange"
      @preview="onPreview"
    >
      <span class="btn"><i class="iconfont iconicon-test15 upload-btn" />{{ data.labelname || $t('message["986"]') }}</span>
      <span
        v-if="!data.hideLimitText"
        class="fs-gray"
      >{{ $t('message["1591"]') }}</span>
    </a-upload>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
import { upyunUpload } from '@/lib/config'
import { uploadSignature } from '@/services/index'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      action: upyunUpload,
      params: {
        policy: '',
        signature: '',
        file: []
      },
      fileList: this.data.fieldvalue || null,
      fileUrls: []
      /* fileList: [{
        uid: '-1',
        name: 'xxx.png',
        status: 'done',
        url: 'http://www.baidu.com/xxx.png'
      }] */
    }
  },
  computed: {
    accept () {
      return this.data.accept || '*'
    }
  },
  created () {
    this.setDefault()
    // this.data.messages.custom = this.data.message
    // this.data.rules.custom = this.validateFile
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    setDefault () {
      if (!this.fileList.length) return
      this.fileList = this.fileList.map(item => {
        item.uid = item.id || 'uid' + Math.random()
        item.name = item.file_name
        item.url = item.file_url
        item.description = item.name
        item.href = item.file_url
        item.title = this.$t('message["1304"]')
        return item
      })
    },
    handleChange ({ file, fileList }) {
      // console.log(file, fileList)

      if (file.status === 'error') {
        let index = fileList.find(item => item.name === file.name)
        fileList = fileList.slice(index, 1)
      }
      if (file.status === 'done') {
        this.$message.success(`${file.name}${this.$t('message["1269"]')}`)
      }

      fileList = fileList.map((file, i) => {
        if (file.response) {
          let index = fileList.length - this.fileUrls.length
          if (i >= index) {
            file.file_name = file.name
            file.file_url = this.fileUrls[i - index]
            file.file_size = file.size
            file.file_type = file.type
            file.description = file.name
            file.href = file.file_url
            file.title = this.$t('message["1304"]')
          }
        }
        return file
      })

      this.fileList = fileList
      this.data.fieldvalue = this.fileList
      this.$emit('change', this.data.fieldvalue)
    },
    async beforeUpload (file) {
      let vm = this
      return new Promise(async (resolve, reject) => {
        if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
          this.$message.error(this.$t('message["1267"]'))
          return false
        }
        if (this.accept.indexOf('image') !== -1 && file.type && file.type.indexOf('image') === -1) {
          this.$message.error(this.$t('message["1599"]'))
          return false
        }
        const chain = await uploadSignature()
        chain.config({
          tip: false
        })
          .params({
            'filename': [file.name] // 文件本地路径
          })
          .onNetSuccess(({ data = {} }) => {
            let { message = '', error } = data
            if (message && error) {
              this.$message.error(message)
            }
          })
          .onSuccess(async ([data = {}]) => {
            const {
              policy,
              signature,
              domain,
              upyunurl,
              _upt
            } = data

            if (policy && signature) {
              vm.file_url = domain + _upt
              vm.params.policy = policy
              vm.params.signature = signature
              vm.action = upyunurl

              vm.fileUrls.push(vm.file_url)
              return resolve(true)
            } else {
              return false
            }
          })
          .fetch()
      })
    },
    handleRemove (file) {
      this.data.fieldvalue = this.fileList.filter(item => item.file_url !== file.url)
    },
    onPreview (file) {
      if (file.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(file.url || file.file_url)
            this.$downloadFile(file.url || file.file_url)
          }
        })
      } else {
        let i = this.fileList.findIndex(item => item.file_url === file.file_url)
        this.$bus.$emit('getFileGallery', this.fileList, i)
      }
    },
    validateFile () {
      let { fieldtype = '', fieldvalue = {}, isneeded, message } = this.data

      this.data.messages.custom = ''

      if (fieldtype !== 'file' || !isneeded) {
        return true
      }
      if (fieldvalue.length) {
        return true
      } else {
        this.data.messages.custom = message || ''
        return false
      }
    },
    resetValidate () {
      this.$refs.formItem.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  margin-right: 16px;
  color: #d6d6d6;
}
.fs-gray,
.btn {
  font-size: 16px;
}
.fs-gray {
  color: #d6d6d6;
}
::v-deep .upload-btn {
  color: #d6d6d6;
}
::v-deep .ant-form-item-children {
  display: flex;
}
::v-deep .ant-upload-list {
  width: 280px;
  padding-right: 24px;
}
::v-deep .ant-form-item {
  margin: 0 !important;
}
::v-deep .ant-upload-list-item {
  margin: 0;
  height: 56px;
  line-height: 56px;
  // border-top: solid 1px #d6d6d6;
}
::v-deep .ant-upload-list-item:after {
  content: '';
  display: block;
  position: absolute;
  border-top: 1px solid #ebebeb;
  left: 0;
  top: 0;
  // width: 100%;
  width: 200%;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 bottom;
  transform-origin: 0 bottom;
}
::v-deep .anticon-paper-clip {
  top: 50%;
  margin-top: -7px;
}
::v-deep .ant-upload-list-item-name {
  padding-right: 10px;
  color: #5077aa;
  cursor: pointer;
}
::v-deep .ant-upload-list-item .anticon-close {
  opacity: 1;
  font-size: 16px;
  top: 50%;
  margin-top: -7px;
}
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
  .ant-upload-list-item:after {
    width: 200%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
  .ant-upload-list-item:after {
    width: 300%;
    -webkit-transform: scale(0.333);
    transform: scale(0.333);
  }
}
</style>
